<template>
<div style="width: 600px;    border: 1px solid #EEEEEE;background: #FFFFFF;" >
      <!-- <div v-for="(data, index) in datas" :key="index"   >
          <div  style="height: 60px;border: 0px solid #EEEEEE;" > 
            <img  style="width: 30px; height: 30px;border-radius: 50%;margin-left: 20px;position: absolute;margin-top: 10px"/> 
            <span  style="margin-left: 60px;position: absolute;margin-top: 10px">{{data.name}} </span>
            <span style="  margin-top: 10px;float: right;margin-right: 10px;">{{data.address}}</span>
          </div>
          <div style="margin-left: 60px;height: 100px;">{{data.address}} </div>
      </div> -->
       <el-tabs v-model="activeName" @tab-click="handleClick" class="orderList-el-tabs"  >
                  <el-tab-pane label="aaa"  name="allOrder" v-loading="AllLoading"></el-tab-pane>
                  <el-tab-pane label="bbb"  name="allOrder" v-loading="AllLoading"></el-tab-pane>
                  <el-tab-pane label="dddd"  name="allOrder" v-loading="AllLoading"></el-tab-pane>
                  <el-tab-pane label="ddsss"  name="allOrder" v-loading="AllLoading"></el-tab-pane>
       </el-tabs>
  </div>
</template>
 <script>
 import $ from 'jquery'
 export default {
    data() {
      return {
        visible: false,
        datas: [{
          id: 1,
          date: '2016-05-02',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1518 弄'
        }, {
          id: 2,
          date: '2016-05-04',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1517 弄'
        }],AllLoading:true
      };
    },
   
     methods:{
       
          
      
     },
    components:{
      
    }
  };
//  import  '../assets/js/jquery-1.11.0.min.js'
      /*实现结算的动态浮动的效果*/
    //   $(function () {
    //      var $top = $(".cartFooter"), wheight = $(window).height(), dheihgt = $(document).height();
    //       wheight < dheihgt ? $top.addClass("cartFixed") : $top.removeClass("cartFixed");
    //       $(window).scroll(function () {
    //           ($(window).scrollTop() >= $(document).height() - $(window).height()) ? $top.removeClass("cartFixed") : $top.addClass("cartFixed");
    //      })
    //  })
 </script>
<style >

  /*正常的css*/
  .cartFooter{
      border:1px solid #ddd;
      background:#fff;
      color:#333;
      height:50px;
      line-height:50px;
     padding:0 0 0 15px;
      margin:20px 0;
     z-index:10;
 }
 .cartFooter a{
     color:#333;
 }
 /*浮动效果*/
.cartFixed{
     position:fixed;
     bottom:0;
     left:0;
     width:100%;
     background:#fff;
     box-shadow:0 -1px 8px rgba(0,1,1,.08);
     margin:0;
 }
 .cartFixed .cartWidth{
     width:1220px;
     margin:0 auto;
 }
 .cartFixed .settLement{
     line-height: 50px;
     height: 50px;
 }

</style>


// WEBPACK FOOTER //
// test.vue?3dcaada5